import { Button, Col, Container, Row } from "react-bootstrap";
import { useGet } from "../../../components/Fetch/useFetch.tsx";
import MultiSelectFilterFromList from "../../../components/Filter/MultiSelectFilterFromList.tsx";
import SelectInputBar from "../../../components/Filter/SelectInputBar.tsx";
import { FieldSet } from "../../../components/Form/Form.tsx";
import SelectEnumOption from "../../../components/Form/SelectEnumOption.tsx";
import DATE_FILTER, {
  LAST_MESSAGE_FILTER,
} from "../../../enums/FilterEvent.tsx";
import url from "../../../module/fetch.tsx";

const FilterEvent = ({
  criseId,
  setSearchParam,
  run,
  statut,
}: {
  criseId: string;
  run: any;
  setSearchParam: any;
  statut: string;
}) => {
  const typeCriseState = useGet(
    url`/api/crise/${criseId}/get-type-event-from-crise/${statut}`,
  )?.data?.[0];

  const setValue = (name: string, value: any) => {
    setSearchParam((previous: any) => ({
      ...(previous || {}),
      [name]:
        value === "0" || value === "" || value === "[]" ? undefined : value,
    }));
  };

  const allTags: string[] =
    typeCriseState?.evenement?.flatMap((event: { evenementTags: any[] }) => {
      return event.evenementTags?.map((tagName) => tagName.trim()) || [];
    }) || [];

  const uniqueTags: { id: string; libelle: string }[] = [];
  allTags
    .filter((tagName: string) => tagName !== "")
    .forEach((tagName) => {
      const isDuplicate = uniqueTags.some((tag) => tag.libelle === tagName);

      if (!isDuplicate) {
        uniqueTags.push({
          id: tagName,
          libelle: tagName,
        });
      }
    });

  return (
    <Container>
      <FieldSet title={"Filtrer les évènements"}>
        <Row>
          <p>Type d&apos;évènement</p>
          <MultiSelectFilterFromList
            name={"listTypeEvent"}
            listIdCodeLibelle={typeCriseState?.typeEvenement}
            onChange={(e: { value: string }) =>
              setValue("filterType", e.value.length > 0 ? e.value : null)
            }
          />
        </Row>

        <Row>
          <Col>
            <p>Auteur</p>
            <MultiSelectFilterFromList
              name={"listAuteur"}
              listIdCodeLibelle={typeCriseState?.utilisateur}
              onChange={(e: { value: string }) =>
                setValue("filterAuthor", e.value.length > 0 ? e.value : null)
              }
            />
          </Col>

          <Col>
            <p>Tags</p>
            <MultiSelectFilterFromList
              name={"filterTag"}
              listIdCodeLibelle={uniqueTags}
              onChange={(e: { value: string }) =>
                setValue("filterTag", e.value.length > 0 ? e.value : null)
              }
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <p>Dernier message</p>
            <SelectEnumOption
              options={LAST_MESSAGE_FILTER}
              name={"dernierMessage"}
              onChange={(e: { value: string }) =>
                setValue("filterMessage", e.value)
              }
            />
          </Col>

          <Col>
            <p>Importance</p>
            <SelectInputBar
              step={1}
              min={0}
              name={"evenementImportance"}
              max={5}
              required={false}
              onChange={(e: { value: string }) =>
                setValue("filterImportance", e.value)
              }
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <p>Statut</p>
            <SelectEnumOption
              options={DATE_FILTER}
              name={"statut"}
              onChange={(e: { value: string }) =>
                setValue("filterStatut", e.value)
              }
            />
          </Col>

          <Col className="text-center">
            <Button className="mt-4" onClick={() => run()}>
              Rechercher
            </Button>
          </Col>
        </Row>
      </FieldSet>
      <br />
    </Container>
  );
};

export default FilterEvent;
